import { BoxProps } from '@mui/system';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { observer } from 'mobx-react-lite';
import { useService } from '~/services/service.base';
import { WrapperService } from '~/services/service.wrapper';

export const UserTopMenu: FC<BoxProps> = observer(() => {
    const wrapperService = useService(WrapperService);
    const { authService } = wrapperService;

    const [open, setOpen] = useState<boolean>(false);
    const handleClickToggleMenu = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const navigate = useNavigate();
    const goToAccount = () => {
        handleClose();
        navigate(ROUTES.PURCHASE_HISTORY.path);
    };

    const logout = () => {
        handleClose();
        authService.logout();

        const privatePages = [ROUTES.PERSONAL_INFO.path as string, ROUTES.ACCOUNT_PAYMENTS.path as string];

        if (privatePages.includes(location.pathname)) {
            navigate(ROUTES.MAIN.path);
        }
    };

    return (
        <div className="top-menu-wrap">
            <div className="username-wrap">{authService.currentUser?.displayName}</div>
            <ClickAwayListener onClickAway={handleClose}>
                <div className="user-avatar-wrap" onClick={handleClickToggleMenu}>
                    <figure>
                        <img src={authService.currentUser?.imageUrl} />
                    </figure>
                    {open && (
                        <ul className="dropdown-menu">
                            <li>
                                <div className="dropdown-item">
                                    <div className="user-menu-icon">
                                        <figure>
                                            <img src="/assets/img/letter-w-user-menu.svg" />
                                        </figure>
                                    </div>
                                    <div className="user-menu-text">WDollars ${authService.currentUser?.balance}</div>
                                </div>
                            </li>
                            <li className={!authService.showUnityBanner ? 'unity-separator' : ''}>
                                <div className="dropdown-item">
                                    <div className="user-menu-icon">
                                        <figure>
                                            <img src="/assets/img/free-play-user-menu.svg" />
                                        </figure>
                                    </div>
                                    <div className="user-menu-text">Free Play ${authService.currentUser?.freePlay}</div>
                                </div>
                            </li>
                            {!authService.showUnityBanner && (
                                <React.Fragment>
                                    <li>
                                        <div className="dropdown-item">
                                            <div className="user-menu-icon">
                                                <figure>
                                                    <img src="/assets/img/unity-user-menu.svg" />
                                                </figure>
                                            </div>
                                            <div className="user-menu-text">
                                                Status - <span>{authService.currentUser?.unityTier}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="dropdown-item">
                                            <div className="user-menu-icon">
                                                <figure>
                                                    <img src="/assets/img/unity-user-menu.svg" />
                                                </figure>
                                            </div>
                                            <div className="user-menu-text">
                                                Points {authService.currentUser?.totalUnityPoints}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="dropdown-item">
                                            <div className="user-menu-icon">
                                                <figure>
                                                    <img src="/assets/img/unity-user-menu.svg" />
                                                </figure>
                                            </div>
                                            <div className="user-menu-text">
                                                Tier credits {authService.currentUser?.totalTierCredits}
                                            </div>
                                        </div>
                                    </li>
                                </React.Fragment>
                            )}
                            <li>
                                <div className="user-menu-actions">
                                    <button type="button" className="btn hr-blue-btn" onClick={goToAccount}>
                                        History
                                    </button>
                                    <button type="button" className="btn hr-black-btn" onClick={logout}>
                                        Log out
                                    </button>
                                </div>
                            </li>
                        </ul>
                    )}
                </div>
            </ClickAwayListener>
        </div>
    );
});
